(function($){
    Drupal.behaviors.mo18 = {
        attach() {

            //append to Main content container to avoid element hiding behind other elements in the page
            const $cta_wrapper = $('.MO18__wrapper-js').remove();
            $cta_wrapper.appendTo('.layout-container-js');

            const openClass = 'MO18--open';
            const $closeBtn = $('.MO18__close-js');

            $closeBtn.off()
                .click(toggleAccordion)
                .keypress(toggleAccordion);

            function toggleAccordion(e) {
                if (e.which === 13 || e.type === 'click') {
                    const $element = $(this).closest('.MO18-js');
                    if ($element.hasClass(openClass)) {
                        $element.removeClass(openClass);
                    } else {
                        $element.addClass(openClass);
                    }
                }
            }
        }
    };
})(jQuery);
